import React from "react";

const GOLD = "#C9A227";

// Signal State ID monogram — two squared "staples" forming an "S".
// Top staple: U-turn on the LEFT (opens right).  Bottom staple: U-turn on the RIGHT (opens left).
export const Monogram = ({ size = 40, className = "", color = GOLD, stroke = 7 }) => (
  <svg width={size} height={size} viewBox="41 41 78 78" fill="none"
    className={className} preserveAspectRatio="xMidYMid meet" role="img" aria-label="Signal State ID">
    {/* top staple */}
    <path d="M115 48 H58 A14 14 0 0 0 58 76 H110"
      stroke={color} strokeWidth={stroke} strokeLinecap="round" strokeLinejoin="round" fill="none" />
    {/* bottom staple */}
    <path d="M45 112 H102 A14 14 0 0 0 102 84 H50"
      stroke={color} strokeWidth={stroke} strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </svg>
);

const Wordmark = ({ fontSize, color }) => (
  <span
    style={{
      fontSize, color, fontWeight: 500, textTransform: "uppercase",
      letterSpacing: "0.34em", paddingLeft: "0.34em", lineHeight: 1, whiteSpace: "nowrap",
    }}>
    Signal State ID
  </span>
);

/**
 * layout="stack" → monogram centered above the wordmark (landing / hero lockup)
 * layout="row"   → monogram beside the wordmark (compact page headers)
 */
export const Brandmark = ({ size = 40, layout = "row", wordmark = true, color = GOLD, className = "" }) => {
  if (layout === "stack") {
    return (
      <div className={`flex flex-col items-center ${className}`} data-testid="brandmark">
        <Monogram size={size} />
        {wordmark && <div style={{ marginTop: size * 0.14 }}><Wordmark fontSize={size * 0.28} color={color} /></div>}
      </div>
    );
  }
  return (
    <div className={`inline-flex items-center ${className}`} style={{ gap: size * 0.26 }} data-testid="brandmark">
      <Monogram size={size} />
      {wordmark && <Wordmark fontSize={size * 0.42} color={color} />}
    </div>
  );
};

export default Brandmark;
